export default __webpack_public_path__ + "static/media/default_pic.d812ddc5.svg";